import 'scss/project-page.scss';
import 'scss/react-app.scss';

import ShareProjectPage from 'components/projects/pages/ShareProjectPage';
import ReactUJS from 'javascripts/ujs/react_ujs';

import.meta.glob('../images/*.{gif,jpg,png,svg}');

window.ReactUJS = ReactUJS;

window.ReactComponents = {
  ShareProjectPage,
};
